module.exports = __webpack_public_path__ + "efaf32b41d7671a4088bad58bf7fe0a8.png";